import { render, staticRenderFns } from "./chassis.vue?vue&type=template&id=2e4e9621&"
import script from "./chassis.vue?vue&type=script&lang=js&"
export * from "./chassis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports